// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onedoc_floating_toolbar {
  box-sizing: border-box;
  z-index: 4 !important;
  align-items: center !important;
  display: inline-flex !important;
  border-radius: calc(var(--cms-border-radius-lg, 8) * 1px) !important;
  background-color: var(--cms-color-bg-elevated, #fff) !important;
  box-shadow:
    0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    0px 3px 6px -4px rgba(0, 0, 0, 0.12),
    0px 9px 28px 8px rgba(0, 0, 0, 0.05) !important;
  height: unset !important;
}

.onedoc_floating_toolbar .MuiStack-root {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  height: unset !important;
  padding: 0px;
}

.onedoc_floating_toolbar .MuiStack-root > div {
  margin-left: 0px !important;
}

.onedoc_floating_toolbar .toolbar__button__wrapper {
  display: flex;
  align-items: flex-start;
  margin-left: 0px;
  padding: calc(var(--cms-padding-xxs, 4) * 1px);
}

.toolbar__button__wrapper .toolbar__button {
  fill: var(--cms-color-text);
  display: flex;
  align-items: center !important;
  justify-content: center !important;
  padding: 0px calc(var(--cms-padding-xxs, 8) * 1px);
  align-items: center;
  gap: calc(var(--cms-padding-xxs) * 1px);
}

.toolbar__button__wrapper .toolbar__button .ant-space-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.toolbar__button__wrapper .toolbar__button .anticon svg {
  width: var(--editor-toolbar-icon-size);
  height: var(--editor-toolbar-icon-size);
}

.toolbar__button__wrapper .toolbar__button .anticon.sm svg {
  width: var(--editor-toolbar-icon-size-sm) !important;
  height: var(--editor-toolbar-icon-size-sm) !important;
}

.toolbar__button__wrapper .toolbar__button .anticon.lg svg {
  width: var(--editor-toolbar-icon-size-lg) !important;
  height: var(--editor-toolbar-icon-size-lg) !important;
}

.toolbar__button__wrapper .toolbar__button .command__button-text {
  color: var(--cms-color-text, rgba(0, 0, 0, 0.88));
  font-family: var(--cms-font-family, 'SF Pro Text');
  font-size: calc(15 * 1px);
  font-style: normal;
  font-weight: var(--cms-typography-font-weight-strong, 600);
  line-height: var(--cms-line-height-lg, 24px); /* 150% */
}

.toolbar__button__wrapper .toolbar__button .command__button-text.weight-normal {
  font-weight: 400;
}

.onedoc_floating_toolbar .toolbar__divider {
  display: flex;
  width: 2px;
  height: 27px;
  align-items: flex-start;
  gap: 8px;
  margin: 0px calc(var(--cms-margin-xxs, 8) * 1px);
  border-inline-start: 2px solid var(--cms-color-border) !important;
}

/* .onedoc_floating_toolbar .toolbar__button__wrapper {
  max-height: var(--ant-editor-toolbar-height, 32px);
  min-height: var(--ant-editor-toolbar-height, 32px);
  margin: 0 !important;
} */
/* 
.onedoc_floating_toolbar .toolbar__button__wrapper .toolbar__button {
  padding: var(--ant-padding-xxs, 4px);
  min-width: var(--ant-editor-toolbar-button-height, 32px);
  height: var(--ant-editor-toolbar-button-height, 32px);
} */

/* .onedoc_floating_toolbar .toolbar__button__wrapper .toolbar__button .ant-btn-icon {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
} */

/* .toolbar__button__dropdown .ant-dropdown-menu {
  display: flex;
  width: 180px;
  padding: var(--ant-padding-xxs, 4px);
  flex-direction: column;
  align-items: flex-start;
  border-radius: var(--ant-border-radius-lg, 8px);
  background: var(--ant-color-bg-elevated, #fff);
  box-shadow:
    0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    0px 3px 6px -4px rgba(0, 0, 0, 0.12),
    0px 9px 28px 8px rgba(0, 0, 0, 0.05);
}

.toolbar__button__dropdown .ant-dropdown-menu-item {
  display: flex !important;
  height: var(--ant-control-height, 32px) !important;
  padding: var(--ant-dropdown-padding-block, 5px) var(--ant-control-padding-horizontal, 12px) !important;
  border-radius: var(--ant-border-radius-sm, 4px) !important;
  gap: var(--ant-margin-xs, 8px) !important;
  align-items: center !important;
  align-self: stretch !important;
} */

.floating-comment-panel {
  padding: calc(var(--cms-padding-xs, 8) * 1px);
  min-height: 32px;
  min-width: 500px;
  max-width: 500px;
  border-radius: calc(var(--cms-border-radius) * 1px);
  border: 1px solid var(--cms-color-border);
}

.floating-comment-panel .comment-editor-wrapper {
  width: 436px;
}

.floating-comment-panel .remirror-theme .ProseMirror {
  min-height: unset !important;
}

.floating-comment-panel .remirror-editor p {
  margin-bottom: 0px !important;
  padding: 0 !important;
  font-size: calc(var(--cms-font-size) * 1px) !important;
}

.floating-comment-panel
  .edit
  .remirror-editor
  p:first-child:has(br.ProseMirror-trailingBreak:only-child)[data-node-active='true']::after {
  position: absolute;
  top: 12px;
  left: 8px;
  transform: translateY(-50%);
  color: var(--cms-color-text-tertiary);
  font-size: calc(var(--cms-font-size) * 1px);
  font-family: var(--cms-font-family);
  content: 'Add a comment...';
}

.floating-comment-panel .ProseMirror.remirror-editor.remirror-a11y-dark {
  width: 100%;
  padding: 0 calc(var(--cms-padding-xxs) * 1px) 0 calc(var(--cms-padding-xs) * 1px) !important;
}
`, "",{"version":3,"sources":["webpack://./../editor/src/components/FloatingToolbar/FloatingToolbar.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,8BAA8B;EAC9B,+BAA+B;EAC/B,oEAAoE;EACpE,+DAA+D;EAC/D;;;mDAGiD;EACjD,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;EAC9B,kCAAkC;EAClC,kDAAkD;EAClD,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,oDAAoD;EACpD,qDAAqD;AACvD;;AAEA;EACE,oDAAoD;EACpD,qDAAqD;AACvD;;AAEA;EACE,iDAAiD;EACjD,kDAAkD;EAClD,yBAAyB;EACzB,kBAAkB;EAClB,0DAA0D;EAC1D,4CAA4C,EAAE,SAAS;AACzD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,QAAQ;EACR,gDAAgD;EAChD,iEAAiE;AACnE;;AAEA;;;;GAIG;AACH;;;;;GAKG;;AAEH;;;;;GAKG;;AAEH;;;;;;;;;;;;;;;;;;;;;;GAsBG;;AAEH;EACE,6CAA6C;EAC7C,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mDAAmD;EACnD,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;;;;EAIE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,qCAAqC;EACrC,2CAA2C;EAC3C,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,4FAA4F;AAC9F","sourcesContent":[".onedoc_floating_toolbar {\n  box-sizing: border-box;\n  z-index: 4 !important;\n  align-items: center !important;\n  display: inline-flex !important;\n  border-radius: calc(var(--cms-border-radius-lg, 8) * 1px) !important;\n  background-color: var(--cms-color-bg-elevated, #fff) !important;\n  box-shadow:\n    0px 6px 16px 0px rgba(0, 0, 0, 0.08),\n    0px 3px 6px -4px rgba(0, 0, 0, 0.12),\n    0px 9px 28px 8px rgba(0, 0, 0, 0.05) !important;\n  height: unset !important;\n}\n\n.onedoc_floating_toolbar .MuiStack-root {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  background-color: transparent;\n  height: unset !important;\n  padding: 0px;\n}\n\n.onedoc_floating_toolbar .MuiStack-root > div {\n  margin-left: 0px !important;\n}\n\n.onedoc_floating_toolbar .toolbar__button__wrapper {\n  display: flex;\n  align-items: flex-start;\n  margin-left: 0px;\n  padding: calc(var(--cms-padding-xxs, 4) * 1px);\n}\n\n.toolbar__button__wrapper .toolbar__button {\n  fill: var(--cms-color-text);\n  display: flex;\n  align-items: center !important;\n  justify-content: center !important;\n  padding: 0px calc(var(--cms-padding-xxs, 8) * 1px);\n  align-items: center;\n  gap: calc(var(--cms-padding-xxs) * 1px);\n}\n\n.toolbar__button__wrapper .toolbar__button .ant-space-item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.toolbar__button__wrapper .toolbar__button .anticon svg {\n  width: var(--editor-toolbar-icon-size);\n  height: var(--editor-toolbar-icon-size);\n}\n\n.toolbar__button__wrapper .toolbar__button .anticon.sm svg {\n  width: var(--editor-toolbar-icon-size-sm) !important;\n  height: var(--editor-toolbar-icon-size-sm) !important;\n}\n\n.toolbar__button__wrapper .toolbar__button .anticon.lg svg {\n  width: var(--editor-toolbar-icon-size-lg) !important;\n  height: var(--editor-toolbar-icon-size-lg) !important;\n}\n\n.toolbar__button__wrapper .toolbar__button .command__button-text {\n  color: var(--cms-color-text, rgba(0, 0, 0, 0.88));\n  font-family: var(--cms-font-family, 'SF Pro Text');\n  font-size: calc(15 * 1px);\n  font-style: normal;\n  font-weight: var(--cms-typography-font-weight-strong, 600);\n  line-height: var(--cms-line-height-lg, 24px); /* 150% */\n}\n\n.toolbar__button__wrapper .toolbar__button .command__button-text.weight-normal {\n  font-weight: 400;\n}\n\n.onedoc_floating_toolbar .toolbar__divider {\n  display: flex;\n  width: 2px;\n  height: 27px;\n  align-items: flex-start;\n  gap: 8px;\n  margin: 0px calc(var(--cms-margin-xxs, 8) * 1px);\n  border-inline-start: 2px solid var(--cms-color-border) !important;\n}\n\n/* .onedoc_floating_toolbar .toolbar__button__wrapper {\n  max-height: var(--ant-editor-toolbar-height, 32px);\n  min-height: var(--ant-editor-toolbar-height, 32px);\n  margin: 0 !important;\n} */\n/* \n.onedoc_floating_toolbar .toolbar__button__wrapper .toolbar__button {\n  padding: var(--ant-padding-xxs, 4px);\n  min-width: var(--ant-editor-toolbar-button-height, 32px);\n  height: var(--ant-editor-toolbar-button-height, 32px);\n} */\n\n/* .onedoc_floating_toolbar .toolbar__button__wrapper .toolbar__button .ant-btn-icon {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n} */\n\n/* .toolbar__button__dropdown .ant-dropdown-menu {\n  display: flex;\n  width: 180px;\n  padding: var(--ant-padding-xxs, 4px);\n  flex-direction: column;\n  align-items: flex-start;\n  border-radius: var(--ant-border-radius-lg, 8px);\n  background: var(--ant-color-bg-elevated, #fff);\n  box-shadow:\n    0px 6px 16px 0px rgba(0, 0, 0, 0.08),\n    0px 3px 6px -4px rgba(0, 0, 0, 0.12),\n    0px 9px 28px 8px rgba(0, 0, 0, 0.05);\n}\n\n.toolbar__button__dropdown .ant-dropdown-menu-item {\n  display: flex !important;\n  height: var(--ant-control-height, 32px) !important;\n  padding: var(--ant-dropdown-padding-block, 5px) var(--ant-control-padding-horizontal, 12px) !important;\n  border-radius: var(--ant-border-radius-sm, 4px) !important;\n  gap: var(--ant-margin-xs, 8px) !important;\n  align-items: center !important;\n  align-self: stretch !important;\n} */\n\n.floating-comment-panel {\n  padding: calc(var(--cms-padding-xs, 8) * 1px);\n  min-height: 32px;\n  min-width: 500px;\n  max-width: 500px;\n  border-radius: calc(var(--cms-border-radius) * 1px);\n  border: 1px solid var(--cms-color-border);\n}\n\n.floating-comment-panel .comment-editor-wrapper {\n  width: 436px;\n}\n\n.floating-comment-panel .remirror-theme .ProseMirror {\n  min-height: unset !important;\n}\n\n.floating-comment-panel .remirror-editor p {\n  margin-bottom: 0px !important;\n  padding: 0 !important;\n  font-size: calc(var(--cms-font-size) * 1px) !important;\n}\n\n.floating-comment-panel\n  .edit\n  .remirror-editor\n  p:first-child:has(br.ProseMirror-trailingBreak:only-child)[data-node-active='true']::after {\n  position: absolute;\n  top: 12px;\n  left: 8px;\n  transform: translateY(-50%);\n  color: var(--cms-color-text-tertiary);\n  font-size: calc(var(--cms-font-size) * 1px);\n  font-family: var(--cms-font-family);\n  content: 'Add a comment...';\n}\n\n.floating-comment-panel .ProseMirror.remirror-editor.remirror-a11y-dark {\n  width: 100%;\n  padding: 0 calc(var(--cms-padding-xxs) * 1px) 0 calc(var(--cms-padding-xs) * 1px) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
